import { WARNING_LEVELS, } from '@components/shared/license/license.constants';
var LARGE = 128;
var SMALL = 64;
var UiLicenseUsageComponent = /** @class */ (function () {
    function UiLicenseUsageComponent() {
        this.diameter = LARGE;
        this.warningLevels = WARNING_LEVELS;
        this._size = 'large';
    }
    Object.defineProperty(UiLicenseUsageComponent.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (value) {
            if (!value ||
                this._size === value) {
                return;
            }
            this._size = value;
            var newDiameter = value === 'small' ?
                SMALL :
                LARGE;
            this.diameter = newDiameter;
        },
        enumerable: true,
        configurable: true
    });
    return UiLicenseUsageComponent;
}());
export { UiLicenseUsageComponent };
